type DeltaOp = {
    insert: unknown
    attributes?: Record<string, unknown>
}

type DeltaJson = {
    ops: DeltaOp[]
}

function isInlineMediaOp(op: unknown): op is DeltaOp {
    if (!op || typeof op !== 'object') return false

    const insert = (op as DeltaOp).insert
    return Boolean(insert && typeof insert === 'object' && ('image' in insert || 'video' in insert))
}

export function buildTranslatedAnswerBody(
    originalValue: unknown,
    translationText: string,
): DeltaJson {
    const translatedText = translationText.endsWith('\n') ? translationText : `${translationText}\n`
    const originalOps =
        originalValue &&
        typeof originalValue === 'object' &&
        Array.isArray((originalValue as DeltaJson).ops)
            ? (originalValue as DeltaJson).ops
            : []
    const translatedOp = { insert: translatedText }
    const translatedOps: DeltaOp[] = []
    let insertedTranslation = false

    for (const op of originalOps) {
        if (!insertedTranslation && typeof op?.insert === 'string' && op.insert.trim().length > 0) {
            translatedOps.push(translatedOp)
            insertedTranslation = true
        }
        if (isInlineMediaOp(op)) translatedOps.push(op)
    }

    if (!insertedTranslation) translatedOps.unshift(translatedOp)

    return {
        // Translation responses contain prose only. Replace the original text at
        // its first position while retaining inline media in its original order.
        ops: translatedOps,
    }
}
